import gql from "graphql-tag";

export default gql`
  mutation startConversation($listingId: Int!) {
    startConversation(input: { listingId: $listingId }) {
      conversation {
        id
        listingId
        buyerId
        sellerId
        createdAt
        updatedAt
        carsForSaleByListingId {
          id
          make
          model
          year
          trim
          price
          imageLoc
          active
          sold
        }
        userByBuyerId {
          id
          firstname
          lastname
          profilePictureUrl
        }
        userBySellerId {
          id
          firstname
          lastname
          profilePictureUrl
        }
      }
    }
  }
`;
